module.exports = __webpack_public_path__ + "static/media/Area.dc457d73.svg";